// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2FgYr","errorLogs":"styles_errorLogs__iy0aq"};